import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useLink } from 'react-aria';
import { NavLink as RRDNavLink, useLocation } from 'react-router';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

const NavLink = ({ children, to, lang, ...props }) => {
    const ref = useRef();
    const { linkProps } = useLink(props, ref);
    const location = useLocation();

    return (
        <li
            className={[
                'govuk-header__navigation-item ',
                location?.pathname === to ? 'govuk-header__navigation-item--active' : null
            ].join(' ')}
            role="none"
        >
            <RRDNavLink
                {...linkProps}
                className="govuk-header__link"
                ref={ref}
                to={to}
                role="menuitem"
                lang={lang}
            >
                {children}
            </RRDNavLink>
        </li>
    );
};

NavLink.propTypes = {
    ...defaultAriaProps,
    to: PropTypes.string.isRequired,
    'data-testid': PropTypes.string
};

export default NavLink;
